import { ExitFullscreenIcon, FullscreenIcon } from "../components/Icons";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";
import { useVideoPlayer2Fullscreen } from "../hooks/use-video-player-helpers";
import { isIOS, isMobile, isFullscreenSupported, isIOSVideoFullscreenSupported } from "../utils/device-detection";

export function FullscreenButton() {
  const { isFullscreen, toggleFullscreen } = useVideoPlayer2Fullscreen();
  const player = useVideoPlayer2();
  
  // Check if fullscreen is supported - be more permissive for mobile
  const checkFullscreenSupport = () => {
    const video = player.element;
    if (!video) return false;
    
    // Always show fullscreen button on mobile devices
    if (isMobile()) {
      return true;
    }
    
    // For desktop, check standard fullscreen support
    return isFullscreenSupported();
  };

  // If fullscreen is not supported, don't render the button
  if (!checkFullscreenSupport()) {
    return null;
  }

  return (
    <button
      className="video-player-2-btn video-player-2-fullscreen"
      onClick={toggleFullscreen}
      title={
        isFullscreen
          ? player.trans("exitFullscreen")
          : player.trans("fullscreen")
      }
      aria-label={
        isFullscreen
          ? player.trans("exitFullscreen")
          : player.trans("fullscreen")
      }>
      {isFullscreen ? <ExitFullscreenIcon /> : <FullscreenIcon />}
    </button>
  );
}
